/* eslint-disable */
import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import './Lead.css';
import AuthService from '../../Services/AuthService';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import SuccessMessage from '../AlertMessages/SuccessMsg';


class RegisterLead extends Component {

  state = {
    gender: '',
    school: '',
    suburb: '',
    guardianRelationship: '',
    open: false,
  };


  constructor() {

    super();

    this.Auth = new AuthService();

    this.state = {
      dateOfBirth: '',
      email: '',
      secondaryEmail: '',
      gender: '',
      guardianContact: '',
      guardianPhone: '',
      guardianRelationship: '',
      mobilePhone: '',
      phone: '',
      firstName: '',
      lastName: '',
      teacher1Email: '',
      teacher1Phone: '',
      teacher1Role: '',
      teacher1Contact: '',
      teacher2Email: '',
      teacher2Phone: '',
      teacher2Role: '',
      teacher2Contact: '',
      school: '',
      suburb: '',
      fireRedirect: false,
      lead: false
    }
  }
  componentWillMount() {
    this.state.lead = localStorage.getItem('hasLead');
    if (this.Auth.loggedIn() && this.state.lead == 0) {
      this.state.username = localStorage.getItem('username')
    } else if (!this.Auth.loggedIn()) {
      this.props.history.replace(`/signin`);
    } else if (this.Auth.loggedIn() && this.state.lead == 1) {
      this.props.history.replace(`/`);
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleOpen = () => {
    this.setState({
      open: true
    });
  };


  handleLead = async event => {
    event.preventDefault();
   
    console.log(leadData);

    const url = "https://connect-back-end.scottguo.com/api/user"

    const leadData = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      dateOfBirth: this.state.dateOfBirth,
      gender: this.state.gender,
      email: this.state.email,
      secondaryEmail: this.state.secondaryEmail,
      mobilePhone: this.state.mobilePhone,
      phone: this.state.phone,
      guardianContact: this.state.guardianContact,
      guardianPhone: this.state.guardianPhone,
      guardianRelationship: this.state.guardianRelationship,
      teacher1Email: this.state.teacher1Email,
      teacher1Phone: this.state.teacher1Phone,
      teacher1Role: this.state.teacher1Role,
      teacher1Contact: this.state.teacher1Contact,
      teacher2Email: this.state.teacher2Email,
      teacher2Phone: this.state.teacher2Phone,
      teacher2Role: this.state.teacher2Role,
      teacher2Contact: this.state.teacher2Contact,
      school: this.state.school,
      suburb: this.state.suburb
    }

    const headers = {
      'Content-type': 'application/json'
    }
    if (this.Auth.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.Auth.getToken()
    }
    await fetch(url, {
        method: 'POST',
        body: JSON.stringify(leadData),
        headers
      })
      .then(async res => {
        if(res.ok){
          res.json()
          await this.Auth.hasLead()
            .then(res => {
              console.log(localStorage.getItem('hasLead'))
              if(res){
                console.log(res.data.lead);
                localStorage.setItem('profile',JSON.stringify(res.data.lead));
                localStorage.setItem('username',res.data.lead.name);
                window.location.reload();
                this.props.history.push('/');
              }
              else {
                alert("lead create not successful")
                // window.location.reload();
                // this.props.history.push('/');
              }
            }) 
        }
      })
      .catch(error => console.error('Error:', error))
      // .then(async response => {
      //   console.log('Success:', response)
        
        
      //   this.setState({
      //     fireRedirect: true
      //   })
      // })
  }


render(){

  const { from } = this.props.location.state || '/profile'
  const { fireRedirect } = this.state

return(
   <div style={{
            padding: '15px 50px 75px',
            width: '1200px',
            margin: 'auto',

          }}>
    <div>
        <MuiThemeProvider>
        <h2>SIGNUP TO LEAD</h2>
          <form onSubmit={this.handleLead}>
            <fieldset>
                <legend>Student Details</legend>
            <div>
              <Grid container spacing={12}>
                <Grid item xs={3}>
                  <TextField
                   hintText="Enter your Username"
                   floatingLabelText="First Name"
                   margin="normal"
                   onChange = {(event,newValue) => this.setState({firstName:newValue})}
                   />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                     hintText="Enter your Password"
                     floatingLabelText="Last Name"
                     margin="normal"
                     onChange = {(event,newValue) => this.setState({lastName:newValue})}
                   />
                </Grid>
                <Grid item xs={3}>
                <br/>
                   <TextField
                    margin="normal"
                    onChange = {(event,newValue) => this.setState({dateOfBirth:newValue})}
                    id="date"
                    type="date"
                  />
                </Grid>
 
                <Grid item xs={3}>
                <br/>
                <br/>
                <InputLabel htmlFor="gender-select" style={{ padding: '20px' }}>Select Gender</InputLabel>
                  <Select
                    open={this.state.open}
                    onClose={this.handleClose}
                    onOpen={this.handleOpen}
                    value={this.state.gender}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'gender',
                      id: 'gender-select',
                    }}
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Prefer Not to say">Prefer Not to say</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </Grid>

                <Grid item xs={3}>
                 <TextField
                   hintText="Enter your Email"
                   floatingLabelText="Email"
                   onChange = {(event,newValue) => this.setState({email:newValue})}
                   />
                </Grid>
                
                <Grid item xs={3}>
                  <TextField
                   hintText="Enter your Secondary Email"
                   floatingLabelText="Secondary Email"
                   onChange = {(event,newValue) => this.setState({secondaryEmail:newValue})}
                   />
                </Grid>
                
                <Grid item xs={3}>
                  <TextField
                   hintText="Enter your Mobile Phone"
                   floatingLabelText="Mobile Phone"
                   onChange = {(event,newValue) => this.setState({mobilePhone:newValue})}
                   />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                   hintText="Enter your Phone"
                   floatingLabelText="Phone"
                   onChange = {(event,newValue) => this.setState({phone:newValue})}
                   />
                </Grid>
              </Grid>
            </div>
            </fieldset>
            <br />

             <fieldset>
                <legend>Guardian Contact</legend>
            <div>
              <Grid container spacing={12}>
                <Grid item xs={3}>
                  <TextField
                   hintText="Enter your Guardian Contact"
                   floatingLabelText="Guardian Contact"
                   margin="normal"
                   onChange = {(event,newValue) => this.setState({guardianContact:newValue})}
                   />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                     hintText="Enter your Guardian Phone"
                     floatingLabelText="Guardian Phone"
                     margin="normal"
                     onChange = {(event,newValue) => this.setState({guardianPhone:newValue})}
                   />
                </Grid>
                <Grid item xs={6}>
                  
                  <br/>
                <br/>
                <InputLabel htmlFor="guardian-select" style={{ padding: '20px' }}>Select Guardian Relationship</InputLabel>
                  <Select
                    open={this.state.open}
                    onClose={this.handleClose}
                    onOpen={this.handleOpen}
                    value={this.state.guardianRelationship}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'guardianRelationship',
                      id: 'guardian-select',
                    }}
                  >
                    <MenuItem value="Father">Father</MenuItem>
                    <MenuItem value="Mother">Mother</MenuItem>
                    <MenuItem value="Guardian">Guardian</MenuItem>
                  </Select>
                </Grid>
              </Grid>
            </div>
            </fieldset>
            <br />

            <fieldset>
                <legend>Teacher Contact Details</legend>

            <div>
                  <Grid container spacing={12}>
                    
                    <Grid item xs={3}>
                      <TextField
                       hintText="Enter first Teacher Email"
                       floatingLabelText="First Teacher Email"
                       margin="normal"
                       onChange = {(event,newValue) => this.setState({teacher1Email:newValue})}
                       />
                    </Grid>

                    <Grid item xs={3}>
                      <TextField
                         hintText="Enter First Teacher Phone"
                         floatingLabelText="First Teacher Phone"
                         margin="normal"
                         onChange = {(event,newValue) => this.setState({teacher1Phone:newValue})}
                       />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField
                         hintText="Enter First Teacher Role"
                         floatingLabelText="First Teacher Role"
                         onChange = {(event,newValue) => this.setState({teacher1Role:newValue})}
                         />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField
                         hintText="Enter First Teacher Contact"
                         floatingLabelText="First Teacher Contact"
                         onChange = {(event,newValue) => this.setState({teacher1Contact:newValue})}
                         />
                    </Grid>

                  </Grid>

                  <Grid container spacing={12}>
                      <Grid item xs={3}>
                        <TextField
                         hintText="Enter Second Teacher Email"
                         floatingLabelText="Second Teacher Email"
                         margin="normal"
                         onChange = {(event,newValue) => this.setState({teacher2Email:newValue})}
                         />
                      </Grid>
                    
                      <Grid item xs={3}>
                        <TextField
                           hintText="Enter Second Teacher Phone"
                           floatingLabelText="Second Teacher Phone"
                           margin="normal"
                           onChange = {(event,newValue) => this.setState({teacher2Phone:newValue})}
                         />
                      </Grid>
                      
                      <Grid item xs={3}>
                          <TextField
                           hintText="Enter Second Teacher Role"
                           floatingLabelText="Second Teacher Role"
                           onChange = {(event,newValue) => this.setState({teacher2Role:newValue})}
                           />
                      </Grid>
                      
                      <Grid item xs={3}>
                          <TextField
                           hintText="Enter Second Teacher Contact"
                           floatingLabelText="Second Teacher Contact"
                           onChange = {(event,newValue) => this.setState({teacher2Contact:newValue})}
                           />
                      </Grid>
                      
                       <Grid item xs={3}>
                           <br/>
                        <br/>
                        <InputLabel htmlFor="school-select" style={{ padding: '20px' }}>Select Your School</InputLabel>
                          <Select
                            open={this.state.open}
                            onClose={this.handleClose}
                            onOpen={this.handleOpen}
                            value={this.state.school}
                            onChange={this.handleChange}
                            inputProps={{
                              name: 'school',
                              id: 'school-select',
                            }}
                          >
                          <MenuItem value="Smithton Primary School">Smithton Primary School</MenuItem>
                          <MenuItem value="A.G.B.U. Alexander Primary School">A.G.B.U. Alexander Primary School</MenuItem>
                          <MenuItem value="Abbotsford Primary School">Abbotsford Primary School</MenuItem>
                          <MenuItem value="Abbotsford Public School">Abbotsford Public School</MenuItem>
                          <MenuItem value="Abbotsleigh">Abbotsleigh</MenuItem>
                          <MenuItem value="Abercorn State School">Abercorn State School</MenuItem>
                          <MenuItem value="Aberdeen Public School">Aberdeen Public School</MenuItem>
                          <MenuItem value="Aberfeldie Primary School">Aberfeldie Primary School</MenuItem>
                          </Select>
                      </Grid>
                      <Grid item xs={3}>
                      <br/>
                        <br/>
                        <InputLabel htmlFor="suburb-select" style={{ padding: '20px' }}>Select Your Suburb</InputLabel>
                          <Select
                            open={this.state.open}
                            onClose={this.handleClose}
                            onOpen={this.handleOpen}
                            value={this.state.suburb}
                            onChange={this.handleChange}
                            inputProps={{
                              name: 'suburb',
                              id: 'suburb-select',
                            }}
                          >
                          <MenuItem value="SMITHTON">SMITHTON</MenuItem>
                          <MenuItem value="Abbotsford">Abbotsford</MenuItem>
                          <MenuItem value="Acacia Gardens">Acacia Gardens</MenuItem>
                          <MenuItem value="Abbotsleigh">Abbotsleigh</MenuItem>
                          </Select>
                      </Grid>
                  </Grid>
              
              <br/>
                <Button
                  type="submit"
                  variant="raised"
                  color="primary">
                  Register
                </Button>
              </div>
            </fieldset>
          </form>

          {fireRedirect && (
          <Redirect to={from || '/profile'}/>

          )}
         </MuiThemeProvider>

      </div>
  </div>

  )
  }

}

const style = {
 margin: 15,
};

export default RegisterLead;


// WEBPACK FOOTER //
// ./src/components/CreateLead/LeadForm.js